<template>
    <div class="input-sample-dashboard">
        <div class="reorder-graph-box">
            <b>Reorder graphs</b>
            <draggable v-model="sampleDashboardTracks" @start="drag=true" @end="drag=false">
                <div 
                    class="selection-element"
                    v-for="element in sampleDashboardTracks" 
                    :key="element"
                >
                    <v-icon>
                        mdi-drag-vertical-variant
                    </v-icon>
                    {{ categoryTracks.Mutation.includes(element) ?
                        `${element} Mutation` :
                        element
                        }}
                </div>
            </draggable>
        </div>
        <br>
            <div v-if="twoCohorts()">
            <input type="checkbox" id="discovery" value="discovery" v-model="cohortSelected" />
            <label>&nbsp;Discovery Cohort</label>
            <br>
            <input type="checkbox" id="validation" value="validation" v-model="cohortSelected" />
            <label>&nbsp;Validation Cohort</label>
            <!-- <p>Checked: {{ cohortSelected }}</p> -->
        </div>
        <br>
        <div class="percent-view-box">
            <b>Show as percentages</b>
            <v-switch
                v-model="percentView"
                :label="percentView ? `Showing percentages` : `Showing raw counts`"
            ></v-switch>
        </div>
        
    </div>
</template>

<script>
import { method } from 'lodash'
import categoryTracks from '../refs/categoryTracks'
import categoryTracksPTRC from '../refs/categoryTracks'
import categoryTracksPCC from '../refs/categoryTracksPCC'


import draggable from 'vuedraggable'

export default {
    name: "input-sample-dashboard",
    components: {
            draggable,
        },
    props: ['studySelected'],
    // data() {
    //     return {
    //         categoryTracks,
    //     }
    // },
    data: () => ({
        // categoryTracks: this.studySelected === 'PCC' ? categoryTracksPCC : categoryTracksPTRC,
        // studySelected: this.studySelected
    }),
    computed: {
        categoryTracks() {
            return this.studySelected === 'PCC' ? categoryTracksPCC : categoryTracksPTRC
        },
        percentView: {
            get() { return this.$store.state.SampleDashboard_percentView },
            set(SampleDashboard_percentView) {
                this.$store.dispatch('setSampleDashboardPercentView', {
                    SampleDashboard_percentView
                })
            },
        },
        sampleDashboardTracks: {
            get() {
                    // console.log('get sampleDashboardTracks', this.studySelected)
                    // console.log('get sampleDashboardTracks tracks', this.categoryTracks)
        
                    if (this.studySelected === 'PCC') {
                        return this.$store.state.sampleDashboard_PCCgraphs
                    } else {
                        return this.$store.state.sampleDashboard_PTRCgraphs
                    }
                 },
            set(sampleDashboard_graphs) {
                var dashboard_key = 'PTRCgraphs'
                if (this.studySelected === 'PCC') {
                    dashboard_key = 'PCCgraphs'
                }
                this.$store.dispatch(
                        'setViewAttr',
                        { view: 'sampleDashboard',
                          attrKey: dashboard_key,
                          attrVal: sampleDashboard_graphs }
                )
            },
        },
        cohortSelected: {
            get() { return this.$store.state.SampleDashboard_cohortSelected },
            set(SampleDashboard_cohortSelected) {
                this.$store.dispatch(
                    'setViewAttr', { 
                    view: 'SampleDashboard',
                    attrKey: 'cohortSelected',
                    attrVal: SampleDashboard_cohortSelected
                    }
                )
                // console.log('Input Sample Dashboard cohortSelected', 
                //                 SampleDashboard_cohortSelected,
                //             this.$store.state.SampleDashboard_cohortSelected)
            },
        },
    },
    methods: {
        twoCohorts() {
            return this.studySelected === 'PTRC'
        },
    }
}
</script>

<style scoped>
    .cohort-menu {
        margin: 2px;
    }
    
    .cohort-list a {
        text-decoration-style: dotted;
    }

    .input-list {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }


    .list-element {
        cursor: grab;
        margin: 0 auto;
        width: 100%;
        margin-bottom: 2px;
        display: flex;
        flex-direction: row;
        justify-content: left;
    }

    .selection-element {
        border: solid 1px #bebebe;
        /* border-radius: 10%; */
        margin-right: 5px;
        width: 100%;
        /* width: 260px; */
        padding: 5px;
        overflow-wrap: break-word;
        /* text-overflow: wrap; */
        /* font-size */
    }

    .input-sample-dashboard {
        max-width: 300px;
        min-width: 300px;
        margin-top: 500px;
        overflow-y: scroll;
        margin: 0 auto;
        font-size: 0.9em;
        display: flex;
        flex-direction: column;
    }

    .cohort-list {
        border: solid 1px #bebebe;
        width: 80%;
        margin: 0 auto;
        padding: 10px;
        margin-bottom: 20px;
        font-size: 1.2em;
    }

    .reorder-graph-box {
        border: solid 1px #ebebeb;
        padding: 20px;
    }

    .percent-view-box {
        border: solid 1px #ebebeb;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
</style>